/* eslint-disable */
export const welcomePageEn = {
  'Welcome to Lemasello': 'Welcome to Lemasello',
  'Project Management App': 'Project Management App',
  'Command 8': 'Command 8',
  'Leonid': 'Leonid',
  'Sergey': 'Sergey',
  'Marina': 'Marina',
  'Mentor': 'Mentor',
  'Dmitriy': 'Dmitriy'
};

export const welcomePageRu = {
  'Welcome to Lemasello': 'Добро пожаловать в Lemasello',
  'Project Management App': 'Приложение управления проектами',
  'Command 8': 'Команда 8',
  'Leonid': 'Леонид',
  'Sergey': 'Сергей',
  'Marina': 'Марина',
  'Mentor': 'Ментор',
  'Dmitriy': 'Дмитрий'
};
/* eslint-disable */